import { faro } from '@grafana/faro-web-sdk';

/**
 * Initialize Jam metadata with current user, org, and Faro session context.
 * Call once after auth is available (e.g., in Routes component).
 *
 * Uses the global Jam API (loaded via support script in index.html) rather
 * than the @jam.dev/sdk npm package to avoid ESM/CJS build issues.
 * Under the hood, the SDK just sets window.__jam__.exports.metadata — we
 * do the same thing directly.
 *
 * The callback is invoked lazily by Jam on each bug report, so it always
 * captures the latest user/session state.
 */
export function initJamMetadata(
  getCurrentUser: () => Record<string, unknown> | null | undefined,
  organizationName?: string
) {
  // Ensure the global Jam namespace exists (the support script creates it,
  // but we may run before it finishes loading with async/defer)
  const jamExports = (((window as any).__jam__ ??= {}).exports ??= {});

  jamExports.metadata = () => {
    const user = getCurrentUser();

    return {
      // User context
      userId: user?.id,
      email: user?.emailAddress,
      fullName: user?.firstName && user?.lastName ? `${user.firstName} ${user.lastName}` : undefined,

      // Tenant context
      organizationId: user?.organizationId,
      organizationName,

      // Session linking -- connects Jam reports to Faro/Grafana sessions
      faroSessionId: faro?.api?.getSession()?.id,

      // App context
      currentUrl: window.location.pathname + window.location.search,
      timestamp: new Date().toISOString(),
    };
  };
}
